import { languageToLocaleMap } from '@config/localization';
import { usePreferences } from '@context/preferences.context';

export default function useFormatLocaleDate() {
  const { language } = usePreferences();
  let updatedLanguage = String(language) === 'en-GB' ? 'en-US' : language;

  if (language === 'hk') {
    updatedLanguage = languageToLocaleMap.get(language);
  }

  const formatLocaleDate = (str: string, formatOptions?: Intl.DateTimeFormatOptions) => {
    const date = new Date(str);

    const config = formatOptions || {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    return date.toLocaleDateString(updatedLanguage, config);
  };

  const formatLocaleTime = (str: string, formatOptions?: Intl.DateTimeFormatOptions) => {
    const date = new Date(str);

    const config = formatOptions || {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };

    return date.toLocaleTimeString(updatedLanguage, config);
  };

  return { formatLocaleDate, formatLocaleTime };
}
